<template>
  <div id="campaign">
    <div class="row mt-md-5 text-center">
      <div class="col-md-12 title-image">
        <img src="/static/images/campaign/title.jpg" class="img-fluid" alt="ふしぎなプレゼントキャンペーンのサムネイル画像">
      </div>
      <div class="col-md-12 text-left">
        <h2>おひさまキッチンの世界を体験できる、<br>
        ふしぎなプレゼントキャンペーンをやっています。</h2>
        <p>どんぐりで絵本が買えたり、<br>
        春風をつかまえてくれたお礼にプレゼントを贈ったり。<br>
        今度は、どうぶつさんからどんなお願いが、<br>
        どんな体験が、 はじまるのでしょうか？</p>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/common/line.png" class="img-fluid" alt="黄色の破線">
      </div>
      <!--
      <div class="col-md-12">
        <img src="/static/images/campaign/gorogoro.jpg" class="img-fluid" alt="ごろごろしているパンダくんの画像">
      </div>
      -->
      <FinishCampaign/>
      <div class="col-md-12 line">
        <img src="/static/images/common/line.png" class="img-fluid" alt="黄色の破線">
      </div>
    </div>
    <div class="row mt-md-5 past">
      <div class="col-md-12 past-title">
        <img src="/static/images/common/title-past.png" class="img-fluid" alt="いろいろやってきました">
      </div>
      <div class="col-6 past-event" v-for="campaign in campaigns" >
        <router-link :to="{ name: 'CampaignArchive', params: { code: campaign.code }}">
          <img :src="`/static/images/campaign/archive/${campaign.code}/${campaign.image}`" class="img-fluid" :alt="`${campaign.title}のサムネイル`">
        </router-link>
        <div class="detail row">
          <div class="date col-md-12">{{campaign.date}}</div>
          <div class="title col-md-12" v-html="campaign.title"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import FinishCampaign from './FinishCampaign.vue';
  export default {
    title: 'ふしぎなプレゼントキャンペーン',
    name: 'campaign',
    components: {
      FinishCampaign
    },
    data() {
      return {
        campaigns: []
      };
    },
    mounted() {
      this.load();
    },
    updated: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    },
    methods: {
      load: function(params) {
        axios.get("/static/data/campaigns.csv")
          .then( response => {
            if (response.status == 200) {
              var data = response.data.split('\n');
              var keys = data[0].split(',');
              var list = [];
              for(var i=1;i<data.length-1;++i){
                var values = data[i].split(',');
                var campaign = {};
                keys.forEach( function( key, idx ) {
                  campaign[key] = values[idx]
                })
                if(campaign) {
                  list.push(campaign);
                }
              }
              this.campaigns = list.reverse();
            } else {
              alert(t("fail_to_get_data"))
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Campaign.vue